import axios from 'axios';
import { API_ENDPOINTS, ApiConfigs } from '../../config/apiConfig';
import apiClient from './apiClient';

/**
 * Interface for CSRF token response
 */
export interface CSRFTokenResponse {
  csrf_token: string;
}

/**
 * CSRF token service for securely interacting with the API
 * This service allows fetching a CSRF token that's needed for POST requests
 */
export const csrfTokenApi = {
  /**
   * Get a CSRF token from the server
   * @returns Promise with CSRF token
   */
  getCSRFToken: async (): Promise<string> => {
    try {
      const response = await axios.get<{ data: CSRFTokenResponse }>(
        `${ApiConfigs.baseURL}${API_ENDPOINTS.CSRF_TOKEN}`,
      );
      
      return response.data?.data.csrf_token;
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
      throw error;
    }
  }
};

export default csrfTokenApi;